import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const PromotionHeader = () => {
  const theme = useTheme();

  return (
    <Typography variant="h2" textTransform="uppercase" textAlign="center">
      <Typography color={theme.palette.text.primary} sx={{ font: "inherit" }}>
        full promotion rules
      </Typography>
    </Typography>
  );
};
